/**
 * TDS (Tax Deducted at Source) Interfaces
 * Framework-agnostic type definitions
 */

import { ApiResponse } from '../common/api-response.interface';

/**
 * Main TDS item entity - matches API response structure
 */
export interface TdsItem {
  id: number;
  file_name: string;
  total_count: number;
  batch_status: number;
  batch_status_name: string;
  zip_file_url: string;
  created_at?: string;
  updated_at?: string;
}

/**
 * Request interface for TDS upload
 */
export interface UploadTdsRequest {
  file_name: string;
  zip_file: File;
}

/**
 * API response for getting TDS list
 */
export interface GetTdsListResponse extends ApiResponse {
  data: TdsItem[];
}

/**
 * API response for TDS upload
 */
export interface UploadTdsResponse extends ApiResponse {
  data:
    | string
    | {
        message: string;
        [key: string]: any;
      };
}

/**
 * API response for unzipping TDS
 */
export interface UnzipTdsResponse extends ApiResponse {
  data: {
    message: string;
    [key: string]: any;
  };
}

/**
 * API response for getting TDS Excel
 */
export interface GetTdsExcelResponse extends ApiResponse {
  data: string; // Excel file URL
}

/**
 * TDS batch status enum
 */
export enum TdsBatchStatus {
  Uploaded = 1,
  Unzipped = 2,
  Processed = 3,
}
